import { useLanguage } from "@onesolution/hooks";

export default function PlanningEmptyContent() {
	const { t } = useLanguage();

	return (
		<div className="flex flex-col items-center justify-center size-full gap-4">
			<span className="font-bold text-2xl">{t("operation.empty-now")}</span>
		</div>
	);
}
